import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.upload';
import * as api from '../../../clients/api';

@Injectable()
export class ApiUploadEffects {

    Upload$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_UPLOAD),
        mergeMap((x: ac.PostUploadAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postUpload(x.file).pipe(
                map((result: any) => {
                    return new ac.PostUploadErfolgreichAction(result, x.file, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostUploadFehlerAction(error, x.file, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.UploadService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.UploadService {
        if (this.service === null) {
            this.service = this.injector.get(api.UploadService);
        }
        return this.service;
    }
}
